<template>
  <div>
    <div class="section-title">Program Status Conditions</div>
    <form data-vv-scope="program_status_condition_form">
      <div class="form-group">
        <label>Program Status Field</label>
        <select class="form-control"
                :value="value.field"
                @input="updateField($event.target.value)">
          <option v-for="field in schema"
                  :value="field.name"
                  v-if="['radio-group','select'].includes(field.type)"
          >{{ field.description }}
          </option>
        </select>
        <ul
          v-if="programStatusConditionField"
          class="list-group program-status-conditions-list"
        >
          <li v-for="(option, idx) in programStatusConditionField.values"
              class="list-group-item"
              :class="{'has-error': errors.has('program_status_condition_form.programStatusCondition'+idx)}">
            <div class="row">
              <div class="col-md-6">
                <label>Label</label>
                <input :id="'ps-condition-'+idx"
                       class="form-control"
                       name="Form Name"
                       type="text"
                       :disabled="true"
                       :value="option.label">
              </div>
              <div class="col-md-6">
                <label>Status</label>
                <select class="form-control"
                        v-model="value.conditions[option.label]"
                        :name="'programStatusCondition'+idx"
                        :data-vv-as="'status for '+option.label"
                        v-validate="'required|integer'"
                        @input="$emit('input', value)"
                >
                  <option :value="1">Active</option>
                  <option :value="0">Dismissed</option>
                </select>
              </div>
              <div class="col-md-12">
                <span v-show="errors.has('program_status_condition_form.programStatusCondition'+idx)"
                      class="help-block red">The Program Status is required.</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </form>
  </div>
</template>


<script>
import { watch, computed, getCurrentInstance } from 'vue';

export default {
  props: {
    schema: {
      type: Array,
      required: true
    },
    // Example:
    // {
    //     field: "field-name",
    //     conditions: {"Pending": 1, "Dismissed": 0, ...}
    // }
    value: {
      type: Object,
      required: true
    }
  },
  setup(props, { emit }) {
    const programStatusConditionField = computed(() => props.schema.find(item => item.name === props.value.field))
    const root = getCurrentInstance()

    const updateStatusConditions = (newValues, oldValues) => {
      const oldConditions = props.value.conditions

      props.value.conditions = {};

      if (newValues) {
        newValues.map((item, index) => {
          if (oldConditions && oldConditions.hasOwnProperty(item.label)) {
            props.value.conditions[item.label] = oldConditions[item.label];
          } else {
            if (['Active', 'Follow-Up', 'Pending', 'Waitlist'].includes(item.label)) {
              props.value.conditions[item.label] = 1;
            } else if (item.label === 'Dismissed') {
              props.value.conditions[item.label] = 0;
            } else {
              props.value.conditions[item.label] = null;
            }
          }
        });
      } else {
        // field has been removed, we need to clear value
        updateField(null)
      }
    }

    watch(
      () => programStatusConditionField.value && programStatusConditionField.value.values,
      updateStatusConditions,
      {deep: true}
    )

    const updateField = ((newFieldValue) => {
      props.value.field = newFieldValue;
      emit('input', props.value)
    })

    const validateAll = () => {
      return root.proxy.$validator.validateAll('program_status_condition_form');
    }

    return {
      updateField,
      programStatusConditionField,
      validateAll,
    }
  }
}

</script>

<style scoped lang="scss">
.program-status-conditions-list {
  margin-top: 1em;

  .row {
    .col-md-6:first-child {
      padding-right: 5px;
    }

    .col-md-6:last-child {
      padding-left: 5px;
    }
  }
}
.section-title {
  margin-top: 2em;
  margin-bottom: 1em;
  padding-bottom: 5px;
  font-weight: bold;
  border-bottom: 1px #ddd solid;
}
</style>



// WEBPACK FOOTER //
// VueProgramStatusConditions.vue?0a9dc59a